import type { ConsoleLogger, JSONMarshallerImpl } from '@playq/irt';
import { WebSocketClientTransport } from '@playq/irt';

import { wsEndpoint } from '/constants';

import { BuzzerOnlineHandlers } from './domains/devices/devicesBuzzer';
import { BuzzerHandlers } from './domains/notifications/notificationsBuzzer';
import { BuzzerBlueprintRunHandlers } from './domains/blueprintRunner/blueprintBuzzer';
import type { Context } from './types';

export const createWebsocketTransport = (
  marshaller: JSONMarshallerImpl,
  logger: ConsoleLogger,
  version: 2 | 3
): WebSocketClientTransport<Context> => {
  const transport = new WebSocketClientTransport<Context>(wsEndpoint[version], marshaller, logger);

  transport.registerBuzzer(new BuzzerHandlers(marshaller));
  transport.registerBuzzer(new BuzzerOnlineHandlers(marshaller));
  transport.registerBuzzer(new BuzzerBlueprintRunHandlers(marshaller));

  return transport;
};
